import React from "react";
const EntityContext = React.createContext({
  schemaMapper: null
});
export {
  EntityContext
};
//# sourceMappingURL=EntityProvider.js.map
